import './front.scss';
import { AccordionFront } from './AccordionFront.js';

document.querySelectorAll( '[data-block="accordion"]' ).forEach( ( element ) => {
	new AccordionFront( element );
} );
